import React from "react";

const Disclaimer = () => {
  return (
    <>
      <section
        style={{
          paddingTop: "108px",
          background: "linear-gradient(135deg, #1f3c88 0%, #39a0ed 100%)",
        }}
      >
        <div className="auto-container">
          <div style={{ padding: "42px 0 36px", textAlign: "center", color: "#ffffff" }}>
            <h1 style={{ fontSize: "40px", fontWeight: 700, marginBottom: "8px", color: "#ffffff" }}>
              Disclaimer - Asysta India Private Limited
            </h1>
          </div>
        </div>
      </section>

      <section
        style={{
          background: "linear-gradient(180deg, #eef4ff 0%, #ffffff 100%)",
          padding: "42px 0 80px",
        }}
      >
        <div className="auto-container">
          <div
            style={{
              maxWidth: "980px",
              margin: "0 auto",
              background: "#ffffff",
              borderRadius: "14px",
              boxShadow: "0 12px 30px rgba(15, 39, 73, 0.10)",
              border: "1px solid #e4ebf7",
              padding: "38px 32px",
              color: "#2a2a2a",
              lineHeight: "1.75",
            }}
          >
            <p style={{ marginBottom: "14px", color: "#5c6675", fontWeight: 600 }}>Last Updated: [28/05/2026]</p>
            <p>The information provided on Asysta ("we", "our", "us") and available on <a href="https://www.asysta.in" target="_blank" rel="noreferrer">www.asysta.in</a> ("Website") is for general informational and service-facilitation purposes only. By using our Website, you acknowledge and agree to the terms outlined in this Disclaimer.</p>

            <p><strong>1. No Driving Training Provided by Asysta</strong><br />
              Asysta is not a driving school and does not provide driving training, driving lessons, or any form of hands-on driving instruction.<br />
              All training services are delivered exclusively by independent third-party driving schools ("Service Providers") listed on our platform.
            </p>

            <p><strong>2. Accuracy of Information</strong><br />
              We strive to keep all information accurate and up-to-date, including:<br />
              Driving school details<br />
              Course descriptions<br />
              Pricing<br />
              Availability<br />
              Instructor information<br />
              However, we do not guarantee the accuracy, completeness, or reliability of any information provided by third-party driving schools.<br />
              Driving schools may update their details without notifying us.
            </p>

            <p><strong>3. No Guarantee of Training Outcomes</strong><br />
              Asysta does not guarantee:<br />
              Passing of the Learner's Licence or Driving Licence exam<br />
              Quality or effectiveness of training<br />
              Instructor behaviour or professionalism<br />
              Vehicle condition or safety<br />
              Completion of training within a specific timeframe<br />
              Training outcomes depend entirely on the user's learning ability and the driving school's methods.
            </p>

            <p><strong>4. Third-Party Responsibility</strong><br />
              Driving schools listed on Asysta operate independently. We are not responsible for:<br />
              Instructor behaviour<br />
              Training quality<br />
              Vehicle safety or maintenance<br />
              Scheduling or cancellations<br />
              Any disputes between users and driving schools<br />
              Users must resolve training-related issues directly with the respective driving school.
            </p>

            <p><strong>5. Payments &amp; Refunds</strong><br />
              Payments made through Asysta are processed via third-party payment gateways. We are not liable for:<br />
              Payment failures<br />
              Delays<br />
              Technical issues<br />
              Gateway errors<br />
              Refunds and cancellations are governed by the driving school's policy, not Asysta's, unless explicitly stated otherwise.
            </p>

            <p><strong>6. Mock Tests &amp; Educational Content</strong><br />
              Mock tests, guides, and educational materials on Asysta are provided for practice and informational purposes only.<br />
              We do not guarantee:<br />
              Accuracy of RTO rules<br />
              Acceptance of content by government authorities<br />
              Success in any official exam<br />
              Users should verify official information with their local RTO.
            </p>

            <p><strong>7. External Links</strong><br />
              Our Website may contain links to third-party websites or services. We do not endorse or control these external sites and are not responsible for their content, policies, or practices.
            </p>

            <p><strong>8. No Professional Advice</strong><br />
              Content on Asysta does not constitute:<br />
              Legal advice<br />
              Professional driving advice<br />
              Government guidance<br />
              Safety certification<br />
              Users should consult qualified professionals or official authorities when needed.
            </p>

            <p><strong>9. Limitation of Liability</strong><br />
              To the fullest extent permitted by Indian law, Asysta is not liable for:<br />
              Any direct, indirect, incidental, or consequential damages<br />
              Loss of data, revenue, or business<br />
              Issues arising from third-party driving schools<br />
              Errors, inaccuracies, or omissions on the Website<br />
              Service interruptions or technical failures<br />
              Use of the Website is at your own risk.
            </p>

            <p><strong>10. Changes to This Disclaimer</strong><br />
              We may update this Disclaimer at any time. Changes will be posted on this page with an updated "Last Updated" date.<br />
              Continued use of the Website means you accept the updated Disclaimer.
            </p>

            <p><strong>11. Contact Us</strong><br />
              If you have questions about this Disclaimer, contact us at:<br />
              <i className="fas fa-envelope" aria-hidden="true" style={{ marginRight: "6px" }}></i>
              <a href="mailto:info@asysta.in">[Info@asysta.in]</a>
              <span style={{ display: "inline-block", width: "14px" }}></span>
              <i className="fas fa-globe" aria-hidden="true" style={{ marginRight: "6px" }}></i>
              <a href="https://www.asysta.in" target="_blank" rel="noreferrer">www.asysta.in</a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Disclaimer;
